import React from 'react';
import { cn } from '@/lib/utils';

interface LastUsedBadgeProps {
  className?: string;
}

export function LastUsedBadge({ className }: LastUsedBadgeProps) {
  return (
    <span
      data-testid="last-used-badge"
      className={cn(
        'absolute -right-2 -top-2 rounded-2xl bg-orange-200 px-2 py-0.5 text-xs font-medium tracking-wide text-orange-900',
        className,
      )}
    >
      Last used
    </span>
  );
}

export default LastUsedBadge;
